// removed by extract-text-webpack-plugin
module.exports = {"navbarBrand":"header--navbarBrand--49cdf0","logo":"header--logo--9d59f4","languageItem":"header--languageItem--390840","devHeader":"header--devHeader--db8b8a"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Header/header.scss
// module id = iqGK
// module chunks = 7